import React, { useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../ui/Tabs';
import { IntegrationsSection } from './settings/IntegrationsSection';
import { AccountSettings } from './settings/AccountSettings';
import { TeamSettings } from './settings/TeamSettings';
import { NotificationSettings } from './settings/NotificationSettings';
import { SecuritySettings } from './settings/SecuritySettings';
import { BillingSettings } from './settings/BillingSettings';
export const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState('account');
  return <div className="container mx-auto" data-id="element-1705">
      <div className="mb-6" data-id="element-1706">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1707">Settings</h1>
        <p className="text-gray-600" data-id="element-1708">
          Manage your account settings and configure system preferences
        </p>
      </div>
      <div className="bg-white rounded-lg shadow" data-id="element-1709">
        <div className="border-b border-gray-200" data-id="element-1710">
          <Tabs defaultValue="account" onValueChange={setActiveTab} value={activeTab} data-id="element-1711">
            <div className="px-6 pt-4" data-id="element-1712">
              <TabsList className="flex space-x-1" data-id="element-1713">
                <TabsTrigger value="account" className={`px-4 py-2 rounded-t-lg ${activeTab === 'account' ? 'bg-white border-b-2 border-indigo-600 text-indigo-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-1714">
                  Account
                </TabsTrigger>
                <TabsTrigger value="integrations" className={`px-4 py-2 rounded-t-lg ${activeTab === 'integrations' ? 'bg-white border-b-2 border-indigo-600 text-indigo-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-1715">
                  Integrations
                </TabsTrigger>
                <TabsTrigger value="team" className={`px-4 py-2 rounded-t-lg ${activeTab === 'team' ? 'bg-white border-b-2 border-indigo-600 text-indigo-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-1716">
                  Team
                </TabsTrigger>
                <TabsTrigger value="notifications" className={`px-4 py-2 rounded-t-lg ${activeTab === 'notifications' ? 'bg-white border-b-2 border-indigo-600 text-indigo-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-1717">
                  Notifications
                </TabsTrigger>
                <TabsTrigger value="security" className={`px-4 py-2 rounded-t-lg ${activeTab === 'security' ? 'bg-white border-b-2 border-indigo-600 text-indigo-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-1718">
                  Security
                </TabsTrigger>
                <TabsTrigger value="billing" className={`px-4 py-2 rounded-t-lg ${activeTab === 'billing' ? 'bg-white border-b-2 border-indigo-600 text-indigo-600' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-1719">
                  Billing
                </TabsTrigger>
              </TabsList>
            </div>
            <div className="p-6" data-id="element-1720">
              <TabsContent value="account" data-id="element-1721">
                <AccountSettings data-id="element-1722" />
              </TabsContent>
              <TabsContent value="integrations" data-id="element-1723">
                <IntegrationsSection data-id="element-1724" />
              </TabsContent>
              <TabsContent value="team" data-id="element-1725">
                <TeamSettings data-id="element-1726" />
              </TabsContent>
              <TabsContent value="notifications" data-id="element-1727">
                <NotificationSettings data-id="element-1728" />
              </TabsContent>
              <TabsContent value="security" data-id="element-1729">
                <SecuritySettings data-id="element-1730" />
              </TabsContent>
              <TabsContent value="billing" data-id="element-1731">
                <BillingSettings data-id="element-1732" />
              </TabsContent>
            </div>
          </Tabs>
        </div>
      </div>
    </div>;
};